/* WLT flagship (1/2): "Shipping & dealer details" disclosure in the hero. Without JS the link is an anchor and CSS :target opens the panel. */
(function () {
  'use strict';
  var link = document.querySelector('[data-fl-ship]'), panel = document.getElementById('fl-ship');
  if (!link || !panel) return;
  link.addEventListener('click', function (e) {
    e.preventDefault();
    var open = panel.hasAttribute('hidden');
    if (open) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', '');
    link.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
})();
/* WLT flagship (2/2): category rail */
/* WLT flagship: category quick-nav that filters the product grid IN PLACE.
   Progressive enhancement: without JavaScript every chip is a normal link to its results page.
   With JavaScript: fetch the chip's results page (a real Shopify collection-filter or search URL), swap the product cards into #ProductsList,
   keep a shareable ?fl=<slug> URL (pushState), update count + live region, show a Clear button, restore on Back / Clear.
   The sticky Filter / Sort controls are the theme's own facet form, which already re-renders the grid in place (no reload). When it fires
   (event "collection:rerendered") the chip state is cleared because the grid then reflects the theme filters instead.
   No dependencies. ~4 KB. */
(function () {
  'use strict';
  var rail = document.querySelector('[data-fl-rail]');
  if (!rail || !window.fetch || !window.DOMParser || !window.history || !history.pushState) return;
  var chips = Array.prototype.slice.call(rail.querySelectorAll('a.fl-chip[data-fl-slug]'));
  var allChip = rail.querySelector('[data-fl-all]');
  var statusEl = rail.querySelector('[data-fl-status]');
  var statusText = rail.querySelector('[data-fl-status-text]');
  var clearBtn = rail.querySelector('[data-fl-clear]');
  var live = rail.querySelector('[data-fl-live]');
  var noun = rail.getAttribute('data-fl-noun') || 'products';
  var gridSel = rail.getAttribute('data-fl-grid') || '#ProductsList';
  var grid = document.querySelector(gridSel);
  var container = document.getElementById('ProductGridContainer');
  if (!grid || !container || !chips.length) return;

  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* desktop arrows scroll the tile rail; they hide at the ends */
  var list = rail.querySelector('[data-fl-list]'), prev = rail.querySelector('[data-fl-prev]'), next = rail.querySelector('[data-fl-next]');
  if (list && prev && next) {
    var sync = function () { prev.disabled = list.scrollLeft <= 2; next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2; };
    prev.addEventListener('click', function () { list.scrollBy({ left: -list.clientWidth * 0.8, behavior: reduced ? 'auto' : 'smooth' }); });
    next.addEventListener('click', function () { list.scrollBy({ left: list.clientWidth * 0.8, behavior: reduced ? 'auto' : 'smooth' }); });
    list.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync); sync();
  }
  var base = { html: grid.innerHTML, pagination: paginationOf(container), count: countEl() && countEl().innerHTML, url: stripFl(location.href) };
  var hideUnlabeled = rail.getAttribute('data-fl-ref') === 'hide';
  var active = null, selfUpdating = false, token = 0, cache = {};

  function countEl() { return document.getElementById('ProductCount'); }
  function paginationOf(root) { var n = root.querySelector('nav.pagination'); return n ? n.outerHTML : ''; }
  function stripFl(u) { var x = new URL(u, location.href); x.searchParams.delete('fl'); return x.pathname + x.search + x.hash; }
  function withFl(slug) { var x = new URL(location.href); x.searchParams.set('fl', slug); x.searchParams.delete('page'); return x.pathname + x.search + x.hash; }
  function fetchUrl(href) {
    var x = new URL(href, location.href), cur = new URL(location.href);
    ['preview_theme_id', 'preview_token'].forEach(function (k) { if (cur.searchParams.has(k) && !x.searchParams.has(k)) x.searchParams.set(k, cur.searchParams.get(k)); });
    return x.toString();
  }
  /* prefetch on hover / focus / touchstart so the swap lands inside the 500 ms input window (no layout-shift penalty) */
  function load(chip) {
    var href = chip.getAttribute('href');
    if (!cache[href]) cache[href] = fetch(fetchUrl(href), { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); });
    cache[href].catch(function () { delete cache[href]; });
    return cache[href];
  }
  function say(msg) { if (live) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 30); } }
  function setPressed(chip) {
    chips.forEach(function (c) { c.setAttribute('role', 'button'); c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); c.removeAttribute('aria-busy'); });
    if (allChip) { allChip.setAttribute('role', 'button'); allChip.setAttribute('aria-pressed', chip ? 'false' : 'true'); allChip.removeAttribute('aria-current'); }
  }
  function featured(hide) { var f = document.getElementById('fl-featured'); if (f) f.hidden = !!hide; }
  function pad(n) { return n === 1 ? '1 ' + noun.replace(/s$/, '') : n + ' ' + noun; }

  function swap(html, pagination, countHtml, keepHeight) {
    var h = grid.offsetHeight;
    if (keepHeight) grid.style.minHeight = h + 'px';
    selfUpdating = true;
    grid.innerHTML = html;
    var old = container.querySelector('nav.pagination');
    if (old) old.remove();
    if (pagination) container.insertAdjacentHTML('beforeend', pagination);
    var ce = countEl(); if (ce && countHtml != null) ce.innerHTML = countHtml;
    document.dispatchEvent(new CustomEvent('collection:rerendered', { detail: { source: 'wlt-fl-filter' } }));
    setTimeout(function () { selfUpdating = false; }, 0);
    if (keepHeight) setTimeout(function () { grid.style.minHeight = ''; }, 400);
  }
  function scrollToGrid() {
    var t = document.getElementById('product-grid') || grid;
    var y = t.getBoundingClientRect().top + window.pageYOffset - 150;
    window.scrollTo({ top: Math.max(0, y), behavior: reduced ? 'auto' : 'smooth' });
  }
  function reset(opts) {
    opts = opts || {};
    token++;
    if (active || opts.force) {
      swap(base.html, base.pagination, base.count, true);
    }
    active = null; setPressed(null);
    if (statusEl) statusEl.hidden = true;
    featured(false);
    if (opts.push !== false) history.pushState({ fl: '' }, '', base.url);
    say('Showing all ' + (document.querySelectorAll(gridSel + ' .product-card').length) + ' ' + noun + ' on this page.');
    if (opts.scroll !== false) scrollToGrid();
  }
  function apply(chip, opts) {
    opts = opts || {};
    var my = ++token;
    chip.setAttribute('aria-busy', 'true');
    return load(chip)
      .then(function (txt) {
        if (my !== token) return;
        var doc = new DOMParser().parseFromString(txt, 'text/html');
        var list = doc.querySelector(gridSel);
        var cards = list ? list.querySelectorAll('.product-card') : [];
        if (!list || !cards.length) throw new Error('empty');
        if (hideUnlabeled) {   /* flagship rule: a crossed-out price without a known type (REG./MSRP) is never shown */
          Array.prototype.forEach.call(cards, function (c) {
            var reg = c.querySelector('.wlt-pcard-reg[data-ref="unlabeled"]');
            if (reg) { reg.remove(); var b = c.querySelector('.wlt-pcard-save-badge'); if (b) b.remove(); }
          });
        }
        var cEl = doc.getElementById('ProductCount');
        var total = cEl ? parseInt((cEl.textContent.match(/\d+/) || [cards.length])[0], 10) : cards.length;
        var pag = paginationOf(doc);
        var label = chip.getAttribute('data-fl-label') || chip.textContent.trim();
        swap(list.innerHTML, pag, pad(total), true);
        active = chip; setPressed(chip);
        var tileCount = chip.querySelector('[data-fl-count]'); if (tileCount && !pag) tileCount.textContent = pad(total);   /* keep the tile's number true */
        if (statusEl) { statusEl.hidden = false; statusText.textContent = 'Showing ' + pad(total) + ': ' + label + (pag ? ' (first page)' : ''); }
        featured(true);
        say('Showing ' + pad(total) + ': ' + label + '. ' + (pag ? 'More results on the next page.' : ''));
        if (opts.push !== false) history.pushState({ fl: chip.getAttribute('data-fl-slug') }, '', withFl(chip.getAttribute('data-fl-slug')));
        if (opts.scroll !== false) scrollToGrid();
        try { chip.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {}
      })
      .catch(function () { window.location.href = chip.getAttribute('href'); });
  }

  rail.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.fl-chip');
    if (!a || !rail.contains(a)) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    if (a === allChip) { reset(); return; }
    if (a === active) { reset(); return; }          /* toggle off */
    apply(a);
  });
  ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) {
    rail.addEventListener(ev, function (e) {
      var a = e.target.closest && e.target.closest('a.fl-chip[data-fl-slug]');
      if (a && !cache[a.getAttribute('href')]) load(a).catch(function () {});
    }, { passive: true, capture: true });
  });
  rail.addEventListener('keydown', function (e) {
    if ((e.key === ' ' || e.key === 'Spacebar') && e.target.matches && e.target.matches('a.fl-chip')) { e.preventDefault(); e.target.click(); }
  });
  if (clearBtn) clearBtn.addEventListener('click', function () { reset(); var t = allChip || chips[0]; if (t) t.focus({ preventScroll: true }); });

  window.addEventListener('popstate', function () {
    var slug = new URL(location.href).searchParams.get('fl');
    var chip = slug && chips.filter(function (c) { return c.getAttribute('data-fl-slug') === slug; })[0];
    if (chip) apply(chip, { push: false, scroll: false }); else reset({ push: false, scroll: false });
  });
  /* the theme's own sticky Filter / Sort re-rendered the grid -> chip state no longer describes it */
  document.addEventListener('collection:rerendered', function () {
    if (selfUpdating || !active) return;
    active = null; setPressed(null); if (statusEl) statusEl.hidden = true; featured(false);
    var u = new URL(location.href); if (u.searchParams.has('fl')) { u.searchParams.delete('fl'); history.replaceState(history.state, '', u.pathname + u.search + u.hash); }
    base.html = grid.innerHTML; base.pagination = paginationOf(container); base.count = countEl() && countEl().innerHTML; base.url = stripFl(location.href);
  });

  setPressed(null);
  var initial = new URL(location.href).searchParams.get('fl');
  if (initial) { var c0 = chips.filter(function (c) { return c.getAttribute('data-fl-slug') === initial; })[0]; if (c0) apply(c0, { push: false, scroll: true }); }
})();
